export default __webpack_public_path__ + "static/media/01.30dc13d0.png";